/*
 * KidsInfo
 * 
 * Module to be used for getting kids information
 *
 * @author: Chiran Doshi and Elton Jain
*/

define('KidsInfo',['jquery','JSTemplate','UI','Config','Validation','Toastr','DatePicker'], function ($, template, UI, Config, Validation, Toastr, DatePicker) {
    "use strict";

    var defaults = {},
        o,
        containerId = '',
        months = ['January','February','March','April','May','June','July','August','September','October','November','December'],
        langs = Config.get('lang'),

        kidValidationRules = {
            name: {
                presence: {
                    message: '^' + langs.err_name
                }
            },
            gender: {
                inclusion: {
                    within: ['male','female'],
                    message: '^' + langs.err_gender
                }
            }
        },

        _postData = function(data) {
            $.post('/ajax/user/kids/update',{kids: JSON.stringify(data.kids), dueDate: data.due_date},function(response) {
                if(response.status) {
                    new Toastr({
                        'message': response.message
                    });     
                }
                
            });    
        },

        _addDatePicker = function(input) {

            input.Zebra_DatePicker({
                onClear: function() {
                    var base = $(this);
                    base.attr('data-value','');
                },
                onSelect: function(ev) {

                    var base = $(this),
                        dob = base.val(),
                        temp,year,month,day;

                    if(dob) {
                        base.attr('data-value',dob);
                        temp = Date.parse(dob);
                        if(!isNaN(temp)) {
                            temp = new Date(dob);
                            year = temp.getFullYear();
                            month = temp.getMonth() + 1;
                            day = temp.getDate();
                            dob = day + ' ' + months[month - 1] + ', ' + year;
                        }
                    }

                    base.val(dob);
                }
            });
        },

        // Fetch Kids Info
        _fetchInfo = function() {

            $.post('/ajax/user/kids/get',{},function(response) {
                if(response.status == true) {
    
                    var html = template('tplKidsInfo',{
                        data: response.response,
                        months: months,
                        template: template,
                        langs: langs
                    });

                    $('.kid-loader').remove();

                    UI.$b.append(html);

                    _addDatePicker($('.dob:input'));

                }
            });
        },

        // Bind required events
        _bindEvents = function() {

            UI.$b.on('click','#addKid',function(ev) {
                var html = template('tplAddKid',{
                    kid:{},
                    months: months,
                    langs: langs,
                    type: 'baby'
                });

                $('#kidsInfoParent').removeClass('empty');

                $('#kidsInfoParent > .actions').before(html);

                _addDatePicker($('.dob:input'));

            });


            // On click of save button
            UI.$b.on('click','#saveKidsInfo',function(ev) {

                var kids = $('.kid-info.baby'),
                    data = [],
                    children = [],
                    validation,
                    year, month, day, dob, base,
                    send = true,
                    due_date;

                due_date = $('.kid-info.pregnancy').find('.dob').attr('data-value');

                for(var i = 0;i < kids.length;i++) {

                    base = $(kids[i]);

                    dob = base.find('.dob').attr('data-value');

                    children[i] = {
                        gender: base.find('.gender option:selected').val(),
                        dob: dob,
                        name: base.find('.name').val()
                    };

                    validation = new Validation({
                        type: 'json',
                        allConstraints: kidValidationRules,
                        value: children[i]
                    });

                    if (validation.isValid() !== true) {
                        send = false;
                    } else if(isNaN(Date.parse(dob))) {
                        new Toastr({
                            'message': langs.err_birthday,
                            'icon': 'ion-alert',
                            'class': 'toastr-error'
                        });    
                        send = false;
                    }
                }

                if(send) {
                    _postData({kids: children, due_date:due_date});
                }
                
            });

            // On click of delete child button
            UI.$b.on('click','.btn-delete-child',function(ev) {
                var parent = $(this).closest('.kid-info');
                parent.hide('fast', function(){ 
                    parent.remove(); 
                    if($('.kid-info').length == 0) {
                        $('#kidsInfoParent').addClass('empty');
                    }
                });
            });
        },



        init = function(options) {
            o = $.extend(defaults, options);

            _fetchInfo();

            _bindEvents();

        };
    
    return {
        init: init
    };
});
